<template>
  <div class="d-flex position-relative">
    <label v-if="label" class="theme-labels">{{ label }}</label>

    <select
      :value="modelValue"
      class="custom-select"
      @input="$emit('update:modelValue', $event.target.value)"
    >
      <option
        v-for="item in items"
        :key="item?.value || item"
        :value="item?.value || item"
      >
        {{ item?.label || item }}
      </option>
    </select>

    <img
      class="position-absolute chevron-down"
      src="@/assets/images/chevron-down.svg"
    />
  </div>
</template>

<script>
export default {
  props: ["modelValue", "items", "label"],
};
</script>

<style>
.theme-labels {
  color: #010101;
  display: block;
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 20px;
  margin: 4px 8px 4px 0;
}

.custom-select {
  background-color: var(--background-color-primary);
  color: var(--color-primary-text);
  border: 1px solid var(--color-border-dark);
  border-radius: 4px;
  padding: 8px 12px;
  padding-right: 24px;
  max-width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.chevron-down {
  top: 50%;
  transform: translateY(-50%);
  right: 8px;
  pointer-events: none;
}
</style>
